module.exports = __webpack_public_path__ + "img/trail-of-bits.46038cbe.jpeg";